// 계약 액션(rpc) — 계약 상세의 발송·파기·해지와 초안 편집의 저장.
import { rpc } from "@/api/client";

export const saveContractDraft = (contractId: string, input: unknown, baseRev: number) =>
  rpc("contract/actions/saveContractDraft", contractId, input, baseRev);

export const sendContract = (contractId: string, input: unknown) => rpc("contract/actions/sendContract", contractId, input);

export const voidContract = (contractId: string, input: unknown) => rpc("contract/actions/voidContract", contractId, input);

export const terminateContract = (contractId: string, input: unknown) => rpc("contract/actions/terminateContract", contractId, input);

export const createContractFromQuote = (quoteId: string) => rpc("contract/actions/createContractFromQuote", quoteId);
